import dropRight from 'lodash/dropRight';
import { undoableReducer } from '../../undoableReducer';
import { DATA_UPDATE_ROW, DATA_ROW_REMOVE, DATA_MARK_ERRORS_AS_DIRTY, DATA_UNDO, DATA_REDO, DATA_UNDO_ALL } from './types';
/**
 * Traverse the path and at the last path runs callback.
 */ const updateNestedPath = function(row, path, remainingPaths, callback) {
    return row.updateIn(path, (y)=>{
        const x = y;
        if (!remainingPaths.length) {
            return callback(x);
        }
        const nextRowInfo = remainingPaths[0];
        const rowIndex = x.getIn([
            'subTables',
            nextRowInfo.tableName,
            'items'
        ]).findIndex((st)=>st.getId() === nextRowInfo.rowId);
        if (rowIndex !== -1) {
            return updateNestedPath(x, [
                'subTables',
                nextRowInfo.tableName,
                'items',
                rowIndex
            ], remainingPaths.slice(1), callback);
        }
        return x;
    });
};
// Immutabletypingsarna verkar inte helt hundra, därav "any" ist för "RowModel".
export const rowReducer = (state, action)=>{
    const actionAny = action;
    switch(actionAny.type){
        case DATA_UPDATE_ROW:
            return state.update((data)=>updateNestedPath(data, [], actionAny.path, actionAny.callback));
        case DATA_ROW_REMOVE:
            {
                const path = dropRight(actionAny.path, 1);
                const removeInfo = actionAny.path[actionAny.path.length - 1];
                return state.update((data)=>updateNestedPath(data, [], path, (x)=>{
                        return x.updateIn([
                            'subTables',
                            removeInfo.tableName
                        ], (subTable2)=>{
                            const subTable = subTable2;
                            return subTable.removeRow(removeInfo.rowId);
                        });
                    }));
            }
        case DATA_MARK_ERRORS_AS_DIRTY:
            {
                return state.markInvalidEntriesAsDirty({
                    validationPredicate: actionAny.validationPredicate
                });
            }
    }
    return state;
};
const subReducer = undoableReducer(rowReducer, {
    actionTypes: [
        DATA_UPDATE_ROW,
        DATA_ROW_REMOVE,
        DATA_MARK_ERRORS_AS_DIRTY,
        DATA_UNDO,
        DATA_REDO,
        DATA_UNDO_ALL
    ],
    undoType: DATA_UNDO,
    undoAllType: DATA_UNDO_ALL,
    redoType: DATA_REDO
});
export const dataReducer = (state = null, action)=>{
    if (!action.detachedId && state) {
        return subReducer(state, action);
    }
    return state;
};
